module.exports = __webpack_public_path__ + "static/media/carlton-logo.86f8a9f6.svg";